<template>
  <div>

    <el-card class="box-card">
      <span style="margin-right: 10px;;">
        Fin Year Start Date:
        <strong>{{ finYearStartDate }}</strong>
      </span>
      <span style="margin-right: 10px;;">
        Current Date:
        <strong>{{ currentDate }}</strong>
      </span>
      <span style="margin-right: 10px;;">
        Current Period:
        <strong>{{ companyLayout.period }}</strong>
      </span>
    </el-card>

    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane label="GL VAT Accounts" name="GLVATAccounts">
        <GLVATAccounts ref="GLVATAccounts"/>
      </el-tab-pane>
      <el-tab-pane label="Clients VAT Summary (Output)" name="clients">
        <clients ref="clients"/>
      </el-tab-pane>
      <!-- <el-tab-pane label="Summary List of Sales (Output)" name="summaryList">
        <summary-list ref="summaryList"/>
      </el-tab-pane> -->
      <el-tab-pane label="Creditable VAT Summary" name="creditable">
        <creditable ref="creditable"/>
      </el-tab-pane>
      <el-tab-pane label="Vendors VAT Summary (Input)" name="vendors">
        <vendors ref="vendors"/>
      </el-tab-pane>
      <el-tab-pane label="Importations VAT Summary (Input)" name="credits">
        <credits ref="credits"/>
      </el-tab-pane>
      <el-tab-pane label="VAT Relief (Esubmission)" name="esubmission">
        <esubmission ref="esubmission"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import moment from 'moment'
  import GLVATAccounts from '@/components/taxation/salesTaxPortal/taxReporting/GLVATAccounts.vue'
  import Clients from '@/components/taxation/salesTaxPortal/taxReporting/Clients.vue'
  import Vendors from '@/components/taxation/salesTaxPortal/taxReporting/Vendors.vue'
  import Credits from '@/components/taxation/salesTaxPortal/taxReporting/Credits.vue'
  import Creditable from '@/components/taxation/salesTaxPortal/taxReporting/Creditable.vue'
  import SummaryList from '@/components/taxation/salesTaxPortal/taxReporting/SummaryList.vue'
  import Esubmission from '@/components/taxation/salesTaxPortal/salesTaxFiling/Esubmission.vue'

  export default {
    name: 'TaxReporting',
    components: {
      GLVATAccounts,
      Clients,
      Vendors,
      Credits,
      SummaryList,
      Creditable,
      Esubmission,
    },
    data() {
      return {
        moment: moment,

        currentDate: moment().format('Do MMM YYYY'),
        activeTab: 'GLVATAccounts',
        msg: 'Sorry, this feature now under development will be ready later.',
      }
    },
    computed:{
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
      finYearStartDate() {
        return this.$store.getters.getCompanyLayout ? moment(this.$store.getters.getCompanyLayout.financialYearStartDate).format('Do MMM YYYY') : null
      },
    },
    methods: {
      loadFirstTab() {
        this.activeTab = 'GLVATAccounts'
        this.$refs['GLVATAccounts'].loadList()
      },
      handleClick(tab, event) {
        if (tab.name === 'GLVATAccounts'){
          this.$refs['GLVATAccounts'].loadList()
        } else if (tab.name === 'clients') {
          this.$refs['clients'].loadList()
        } else if (tab.name === 'vendors') {
          this.$refs['vendors'].loadList()
        } else if (tab.name === 'credits') {
          this.$refs['credits'].loadList()
        } else if (tab.name === 'summaryList') {
          this.$refs['summaryList'].loadList()
        } else if (tab.name === 'creditable') {
          this.$refs['creditable'].loadList()
        } else if (tab.name === 'esubmission'){
          this.$refs['esubmission'].loadList()
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>